import { type ReactNode, createContext, useContext } from 'react';
import {
  type Analytics,
  createAnalytics,
} from '../modules/analytics/analytics';

const initialState: Analytics = createAnalytics({});
const AnalyticsContext = createContext<Analytics>(initialState);

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);

  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  return context;
};

export const AnalyticsProvider = ({
  value,
  children,
}: {
  value: Analytics;
  children?: ReactNode;
}) => (
  <AnalyticsContext.Provider value={value}>
    {children}
  </AnalyticsContext.Provider>
);
